/* global reservationHelper */
const eventsFormReservation = {
	el: {
		formReservation: document.querySelector('.js-form-reservation'),
		formTabs: document.querySelectorAll('.form__tab'),
		formReservationHeader: document.querySelectorAll('.form-reservation__header'),
		formSelects: document.querySelectorAll('.form-table__select select'),
		formSelectCountryName: document.querySelector('.form__field-select[name="ClientCountryName"]'),
		tableCells: document.querySelectorAll('.tab-inner-row'),
		tableHeadings: document.querySelectorAll('.tab-header'),
		btnToggleContentSummary: document.querySelector('.content__summary-toggle'),
		roomTypeInputs: document.querySelectorAll('.js-room-type'),
		roomTypeReset: document.querySelector('.js-room-type-reset')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 75em)'),
		mediumAndUp: window.matchMedia('(min-width: 48em)')
	},

	fxEvents() {
		//set default rate warning
		reservationHelper.fxSetDefaultRateInfo(document.querySelector('.form-table--desktop'))
		
		//updateStyles
		if (this.vars.extraLargeAndUp.matches) {
			document.querySelectorAll('.form-table--desktop .form-table__radio-input').forEach(el => el.addEventListener('click', e => reservationHelper.fxUpdateDesktopTableStylesColumns(e.currentTarget, this.el.tableCells)))

			//update styles inner-rows
			this.el.formSelects.forEach(el => el.addEventListener('change', e => reservationHelper.fxUpdateDesktopTableStylesRows(e.currentTarget)))

		}
		else
			document.querySelectorAll('.form-table--mobile .form-table__radio-input').forEach(el => el.addEventListener('change', e => reservationHelper.fxUpdateMobileTableStyles(e.currentTarget)))

		//update Country code
		this.el.formSelectCountryName.addEventListener('change', e => reservationHelper.fxUpdateCountryCode(e.currentTarget))
		//toggle content summary on click - mobile
		this.el.btnToggleContentSummary.addEventListener('click', e => reservationHelper.fxToggleContentSummary(e.currentTarget))

		this.el.roomTypeInputs.forEach(el => el.addEventListener('change', e => this.fxToggleFilterRoomType(e.currentTarget)))

		this.el.roomTypeReset.addEventListener('click', () => this.fxToggleFilterRoomTypeReset())
	},

	fxToggleFilterRoomType(element) {

		if (element.checked) {
			document.querySelector('.js-room-type-reset').style.display = 'flex'

			const selector = this.vars.extraLargeAndUp.matches ? '.form-table__row' : '.form-table__card',
				displayStyle = this.vars.extraLargeAndUp.matches ? 'flex' : 'block'

			if (element.id === 'beds') {
				document.querySelectorAll(`${selector}[data-room-type="quartos"]`).forEach(el => this.vars.extraLargeAndUp.matches ? el.style.display = 'none' : el.closest('.form-table__card-container').style.display = 'none')
				document.querySelectorAll(`${selector}[data-room-type="camas"]`).forEach(el => this.vars.extraLargeAndUp.matches ? el.style.display = `${displayStyle}` : el.closest('.form-table__card-container').style.display = `${displayStyle}`)
			} else {
				document.querySelectorAll(`${selector}[data-room-type="camas"]`).forEach(el => this.vars.extraLargeAndUp.matches ? el.style.display = 'none' : el.closest('.form-table__card-container').style.display = 'none')
				document.querySelectorAll(`${selector}[data-room-type="quartos"]`).forEach(el => this.vars.extraLargeAndUp.matches ? el.style.display = `${displayStyle}` : el.closest('.form-table__card-container').style.display = `${displayStyle}`)
			}
		}
	},

	fxToggleFilterRoomTypeReset() {
		this.el.roomTypeInputs.forEach(el => el.checked = false)
		document.querySelector('.js-room-type-reset').removeAttribute('style')

		const selector = this.vars.extraLargeAndUp.matches ? '.form-table__row' : '.form-table__card'
		document.querySelectorAll(`${selector}[data-room-type="camas"], ${selector}[data-room-type="quartos"]`).forEach(el => this.vars.extraLargeAndUp.matches ? el.removeAttribute('style') : el.closest('.form-table__card-container').removeAttribute('style'))
	},

	fxUpdateSidePanel() {
		///-update side panel on select/input number change or rateplan change
		const selects = document.querySelectorAll('.form-table__select select')
		const inputs = document.querySelectorAll('.form-table__radio-input')
		selects.forEach(el => el.addEventListener('change', () => reservationHelper.fxUpdateInfo()))
		inputs.forEach(el => el.addEventListener('change', () => reservationHelper.fxUpdateInfo()))
	},

	init() {
		if (this.el.formReservation) {
			this.fxEvents()
			this.fxUpdateSidePanel()
			reservationHelper.fxGoToNextStep('.js-form-reservation-next', '1', this.el.formTabs, this.el.formReservationHeader)
			reservationHelper.fxGoToNextStep('.js-form-reservation-next', '2', this.el.formTabs, this.el.formReservationHeader)
			reservationHelper.fxGoToNextStep('.js-form-reservation-next', '3', this.el.formTabs, this.el.formReservationHeader)
		}
	}
}

eventsFormReservation.init()